import { sum, values } from 'lodash';
// Import Constants
import { CustomerJourneyGroupBlockTypes } from 'constants/common';

export const isBlockGroupReadOnly = (
    blocksTypes: keyof typeof CustomerJourneyGroupBlockTypes,
    blocksCounts: Record<string, number>,
    maxBlocksCounts: number,
) => {
    const count = sum(values(blocksCounts));
    let result = false;
    if (blocksTypes === CustomerJourneyGroupBlockTypes.target) {
        result = result || blocksCounts[blocksTypes] > 0;
    }
    result = result || count >= maxBlocksCounts;

    return result;
};
